// src/context/GlobalDataContext.js
import { createContext, useState, useEffect, useMemo, useCallback } from 'react';
import userService from '../utils/userService';
import api from '../services/api';
import { getUserProfile } from '../services/userService';

const GlobalDataContext = createContext();

export const GlobalDataProvider = ({ children }) => {
  const [allState, setAllState] = useState([]);
  const [isLoadingStates, setIsLoadingStates] = useState(true);
  const [liveStreams] = useState([]);
  const [contentData, setContentData] = useState([]);
  const [contentType,setContentType] = useState('')
  const [randomNumber, setRandomNumber] = useState(null);
  const userId = localStorage.getItem('id')

  // Fetch all states on initial load
  const fetchStates = useCallback(async () => {
    setIsLoadingStates(true);
    try {
      const response = await userService.allStates();
      setAllState(response);
    } catch (error) {
    } finally {
      setIsLoadingStates(false);
    }
  }, []);

  // Live streams are served via Zego now; the old Twilio rooms endpoint
  // this used to call has been removed from the backend, so this is a no-op.
  const fetchLiveStreams = useCallback(async () => {}, []);

  // Fetch content data
  const fetchContent = useCallback(async () => {
    try {
      const payload = {
        curPage: 1,
        perPage: 6,
        sortBy: "created_on",
        direction: "desc",
        whereClause: [],
      };
      const response = await api.post("/content/pagination", payload);
      if (response.data.statusCode === 200) {
        setContentData(response.data.data);
      }
    } catch (error) {
    }
  }, []);

  const fetchProfile = useCallback(async () => {
    if(!userId) return ;
        try {
          const response = await getUserProfile(userId);
          if (response.data.statusCode === 200) {
            setContentType(response.data.data.contentType);
          }
        } catch (error) {
        }
      }, [userId]);


  // Initialize all data
  useEffect(() => {
    // fetchStates();
    fetchProfile();
    setRandomNumber(Math.floor(Math.random() * 90 + 10));
    if (localStorage.getItem("token")) {
      fetchLiveStreams();
      fetchContent();
    }
  }, []);

  const contextValue = useMemo(() => ({
    allState,
    isLoadingStates,
    liveStreams,
    contentData,
    randomNumber,
    fetchStates,
    fetchLiveStreams,
    fetchProfile,
    contentType,
    fetchContent,
  }), [allState, isLoadingStates, liveStreams, contentData, randomNumber, fetchStates, fetchLiveStreams, fetchProfile, contentType, fetchContent]);

  return (
    <GlobalDataContext.Provider value={contextValue}>
      {children}
    </GlobalDataContext.Provider>
  );
};

export default GlobalDataContext;